(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sn-secure-rfq-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const allowedExtensions = ['pdf', 'step', 'stp', 'dwg'];
    const formatBytes = (bytes) => `${(bytes / 1048576).toFixed(1)} MB`;
    const loadTurnstile = () => {
      if (window.turnstile || document.querySelector('script[data-sn-turnstile-script]')) return;
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.dataset.snTurnstileScript = 'true';
      document.head.appendChild(script);
    };

    const initialize = (form) => {
      if (form.dataset.snRfqReady === 'true') return;
      form.dataset.snRfqReady = 'true';
      loadTurnstile();
      const input = form.querySelector('input[type="file"]');
      const list = form.querySelector('[data-file-list]');
      const fileStatus = form.querySelector('[data-file-status]');
      const submitStatus = form.querySelector('[data-submit-status]');
      const maxFiles = Number(form.dataset.maxFiles);
      const maxFileBytes = Number(form.dataset.maxFileBytes);
      const maxTotalBytes = Number(form.dataset.maxTotalBytes);

      const validateFiles = () => {
        const files = Array.from(input.files || []);
        const errors = [];
        let total = 0;
        list.innerHTML = '';
        files.forEach((file) => {
          total += file.size;
          const extension = file.name.split('.').pop().toLowerCase();
          if (!allowedExtensions.includes(extension)) errors.push(`${file.name}: ${form.dataset.msgFormat}`);
          if (file.size > maxFileBytes) errors.push(`${file.name}: ${form.dataset.msgFileSize}`);
          const item = document.createElement('li');
          item.textContent = `${file.name} (${formatBytes(file.size)})`;
          list.appendChild(item);
        });
        if (files.length > maxFiles) errors.push(form.dataset.msgFileCount);
        if (total > maxTotalBytes) errors.push(form.dataset.msgTotalSize);
        fileStatus.textContent = errors.length ? errors.join(' ') : (files.length ? `${files.length} ${form.dataset.msgSelected}, ${formatBytes(total)}` : '');
        fileStatus.dataset.error = errors.length ? 'true' : 'false';
        return errors.length === 0;
      };

      input.addEventListener('change', validateFiles);
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        submitStatus.dataset.error = 'false';
        if (!form.reportValidity() || !validateFiles()) return;
        const endpoint = form.dataset.endpoint.trim();
        if (!endpoint) {
          submitStatus.textContent = form.dataset.msgSafeMode;
          submitStatus.dataset.error = 'true';
          return;
        }
        const submitButton = form.querySelector('button[type="submit"]');
        submitButton.disabled = true;
        submitStatus.textContent = form.dataset.msgSending;
        try {
          const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), credentials: 'omit' });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(payload.error || 'upload-service-error');
          submitStatus.textContent = form.dataset.msgReceived;
          form.reset();
          list.innerHTML = '';
          if (window.turnstile) window.turnstile.reset();
        } catch (error) {
          submitStatus.textContent = error.message === 'upload-service-error' ? form.dataset.msgServiceError : error.message;
          submitStatus.dataset.error = 'true';
          if (window.turnstile) window.turnstile.reset();
        } finally {
          submitButton.disabled = false;
        }
      });
    };

    const initializeAll = (root = document) => root.querySelectorAll('[data-sn-rfq-form]').forEach(initialize);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
    else initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
